
export type GetNotificationsParams = {
recipientId: string;
limit?: number;
since?: string;
};
